import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ModalDelete: false,
    data: {}
  },

  mutations: {
    TModal(state, value) {
      state.ModalDelete = value
    },

    VData(state, value) {
      state.data = value
    },
  }
})